/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Contact_Panel_TitleInputs */

const en_directory_resources_contact_panel_title = /** @type {(inputs: Directory_Resources_Contact_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with a clear note`)
};

const zh_directory_resources_contact_panel_title = /** @type {(inputs: Directory_Resources_Contact_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先说明你的需求`)
};

/**
* | output |
* | --- |
* | "Start with a clear note" |
*
* @param {Directory_Resources_Contact_Panel_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_contact_panel_title = /** @type {((inputs?: Directory_Resources_Contact_Panel_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Contact_Panel_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_contact_panel_title(inputs)
	return zh_directory_resources_contact_panel_title(inputs)
});
export { directory_resources_contact_panel_title as "directory.resources.contact_panel.title" }